import { Table } from "./Table";

export class LinkTable {
    Id: number;
    Name: string;

	LeftTable: Table;
    RightTable: Table;
}